import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { isLogin } from '../../functions/Auth';
import Header from '../Headers/Header';
import { NavLink, useHistory, Redirect, withRouter, Link } from 'react-router-dom';
import UserHeader from '../Headers/UserHeader';
import MenuIcon from '@material-ui/icons/Menu';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faDownload, faCloudUploadAlt, faQuestionCircle, faCog, faCloud, faRoad, faUser, faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { ClickAwayListener } from '@material-ui/core';


//Start Css code ...
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    '& .Mui-selected': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
    '& .MuiTabs-root': {
      minHeight: '35px',
    },
    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent !important',
    },
    '& .MuiTab-root': {
      minWidth: '150px',
    },
    '& .PrivateTabIndicator-colorPrimary-14': {
      backgroundColor: '#24618E',
    },
    '& .MuiAppBar-colorDefault': {
      boxShadow: 'none',
      background: '#fff',
      '& .MuiButtonBase-root': {
        border: '1px solid #24618E',
        borderRadius: '6px 6px 0px 0px',
        minHeight: 'auto',
        borderBottom: 'none',
        color: "#333",
        padding: '5px 10px',
      }
    },
    '& h5': {
      margin: '0px 0 10px',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '16pt',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '26pt',
      },
    }
  },
  mainBlock: {
    padding: '10px',
    position: 'absolute',
    width: '100%',
    float: 'left',
    background: '#fff',
    top: '2%',
    zIndex: '1',
    '& h4': {
      margin: '0',
      color: '#24618E',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20pt',
        marginTop: '30px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '30pt',
        marginTop: '30px',
      },
    },
    '& .MuiPaper-elevation2': {
      boxShadow: 'none',
    },
    '& .focus': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
  },
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24,
    backgroundColor: '#D7D7D7',
    '@media only screen and (max-width: 3500px)': {
      height: '40px',
    },
    '@media only screen and (min-width: 3501px)': {
      height: '60px',
    },
  },
  title: {
    flexGrow: 1,
    color: '#333333',
    fontSize: '24pt',
    fontFamily: 'Avenir_Black',
    marginLeft: '30px'
  },
  signIn: {
    flexGrow: 1,
    color: '#24618E',
    fontSize: '14pt',
    marginLeft: '10px'
  },
  paper: {
    margin: theme.spacing(1),
    paddingBottom: '3px',
  },
  dropMenu: {
    position: 'absolute',
    top: '37px',
    zIndex: '999',
    minWidth: '200px',
    '& li': {
      fontSize: '16px',
      padding: '5px 0px',
      color: 'rgba(36, 97, 142, 1)',
      listStyle: 'none',
    },
    width: '125px',
    padding: '0%',
    '& .MuiPaper-root': {
      border: '1px solid #24618E',
    }
  },
  droplog: {
    top: '55px',
    zIndex: '999',
    position: 'absolute',
    right: '10%',
    width: '150px',
  },
  dropMenuUl: {
    paddingLeft: '10px',
    paddingTop: '5px',
  },
  dropAdminTools: {
    border: '1px solid rgba(0, 167, 93, 1)',
    margin: '5px',
    borderRadius: '5px',
    '& h5': {
      margin: '5px 5px 0',
      fontSize: '16px',
      fontWeight: 'normal',
    },
    '& ul': {
      margin: '2px 5px 0',
      paddingRight: '15px',
      paddingLeft: '25px',
    }
  },
  menuIuseEffectcon: {
    fontSize: '18px',
    marginRight: '10px',
  },
  toolbarIcon: {
    cursor: 'pointer',
  },
  adminMenu: {
    padding: '10px',
  },
  header: {
    position: 'absolute',
    top: '0',
    width: '100%',
    '& .MuiAppBar-colorPrimary': {
      backgroundColor: '#D7D7D7',
      borderBottom: '1px solid #24618E',
      padding: '5px 0',
    },
    '& .MuiToolbar-regular': {
      minHeight: '40px',
    },
    '& .MuiAppBar-root': {
      boxShadow: 'none',
    }
  },
  userIcon: {
    color: '#24618E',
    fontSize: '25px',
    marginTop: '2px',
  },
  headerLogo: {
    textDecoration: 'none',
    width: '100%',
    textAlign: 'center',
    '& img': {
      '@media only screen and (max-width: 3500px)': {
        height: '38px',
        width: '164px',
        marginBottom: '-10px',
      },
      '@media only screen and (min-width: 3501px)': {
        width: '235px',
        height: '55px',
        marginBottom: '-15px',
      },
    }
  }
}));
//End Css code ...

//Start UnderMaintanance component code ...
export default function UnderMaintanance() {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <React.Fragment>

      <div className={classes.header}>
        <div className={classes.root}>
          <CssBaseline />
          <AppBar position="relative">
            <Toolbar className={classes.toolbar}>
              <NavLink to={{ pathname: '/', state: { clicked: true } }} className={classes.headerLogo} style={{}}><img src={require('../../assets/images/dataPointMainLogo.svg')} /></NavLink>
            </Toolbar>
          </AppBar>
        </div>

      </div>

      <div className={classes.mainBlock}>
        <h4>DataPoint is Currently Unavailable</h4>
        <hr style={{ marginTop: '0px' }} />
        <div className={classes.root}>
          <p>DataPoint is currently unavailable due to temporary maintenance. We should be back shortly. </p>
        </div>
      </div>
    </React.Fragment>
  );
}
//End UnderMaintanance component code ...